/**
  * @author Ryan Gladstone
  */

function cacheService($cacheFactory) {
  const service = {};

  service.invalidateCache = (cachedResource) => {
    const $httpDefaultCache = $cacheFactory.get('$http');
    $httpDefaultCache.remove(`api/${cachedResource}`);
  };

  service.invalidateAllCaches = () => {
    service.invalidateCache('tasks/types');
    service.invalidateCache('statuses/workflow');
    service.invalidateCache('statuses/publish');
    service.invalidateCache('icons');
    service.invalidateCache('plans');
    service.invalidateCache('groups');
    service.invalidateCache('users');
  };

  return service;
}

const serviceArray = [
  '$cacheFactory',
  cacheService
];

module.exports = (ngModule) => {
  ngModule.service('cacheService', serviceArray);
};
